import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { roomsChange } from '../../actions';
import { RoomsCheckbox as RoomsCheckboxComponent } from '../../components/RoomsCheckbox';
import { getRooms } from '../../selectors';
import { ERoom } from '../../types/filter';
import { TThunkDispatch } from '../../types/redux/thunk';
import { setQueryParameter } from '../../utils';

export function RoomsCheckbox() {
  const dispatch: TThunkDispatch = useDispatch();
  const rooms = useSelector(getRooms);

  const handleRoomsChange = React.useCallback(
    (event: React.SyntheticEvent, rooms: ERoom[]) => {
      dispatch(roomsChange(rooms));
      setQueryParameter('rooms', rooms.join(','));
    },
    [dispatch],
  );

  return <RoomsCheckboxComponent rooms={rooms} onChange={handleRoomsChange} />;
}
